import ajax from '../utils/request'

export default {
  /**
   * 通过投票id 拉取投票信息
   * @see https://yapi.geekbang.org/project/116/interface/api/19939
   * @param {Number} id 投票id
   * @param {String} aid 文章id
   */
  getVoteById (id, aid) {
    const postData = {
      ids: [id],
      aid
    }
    return ajax({
      url: 'public/v1/exam/getlist',
      data: postData
    }).then(res => {
      if (Array.isArray(res.list) && res.list.length) {
        let resData = res.list[0]
        let data = JSON.parse(res.list[0].question)
        let question = data.questions[0]
        let parseDetails = JSON.parse(question.details)
        let type = 1 // 多选投票题
        // console.log('question', question)
        // console.log(parseDetails)

        if (data && data.questions.length) {
          // 投票类型 类型  1 多选  2 单选 3 pk
          switch (parseDetails.options[0].type || 0) {
            case 100201:
              type = 2
              break
            case 100301:
              type = 1
              break
            case 101201:
              type = 3
              break
          }

          let responseData = {
            id: data.id,
            question_id: question.id,
            end_time: resData.end_time,
            start_time: resData.start_time,
            statistic: resData.statistic && JSON.parse(resData.statistic) || '',
            user_answer: resData.user_answer && JSON.parse(resData.user_answer) || '',
            title: question.title,
            options: parseDetails.options,
            type: type,
            limits: parseDetails.limits
          }

          // 如果是 pk 投票 整理左右双方数据
          if (type === 3) {
            responseData.left = parseDetails.options[0] || {}
            responseData.right = parseDetails.options[1] || {}
          }
          return responseData
        }
      }

      return {}
    })
  },
  /**
   * 提交投票答案
   * @see https://yapi.geekbang.org/project/116/interface/api/19940
   * @param {Object} data 投票答案
   */
  submitVote (data) {
    return ajax({
      signin: true,
      url: 'public/v1/exam/sub',
      data
    })
  }
}
